import React from 'react'
import PropTypes from 'prop-types'
import ReactPlaceholder from 'react-placeholder'
import Placeholder from './Placeholder'

const TrackingStatus = props => {
  let iconClassName = ''
  let classColorText = ''
  switch (props.trackingStatus) {
    case 'Cancelado':
      classColorText = 'color-error h4' // Cancelado
      iconClassName = 'icon icon_close_circle color-error h4  d-inline-block' // Cancelado
      break
    case 'Entregue':
      classColorText = 'color-success' // Pedido Realizado
      iconClassName = 'icon icon_check_circle color-success h4  d-inline-block' // Pedido Realizado
      break
    case 'Confirmado':
      classColorText = 'color-success' // Confirmado
      iconClassName = 'icon icon_check_circle color-success h4  d-inline-block' // Confirmado
      break
    case 'Seu produto foi solicitado':
      classColorText = 'color-success'
      iconClassName = 'icon icon_check_circle color-success h4  d-inline-block'
      break
    case 'Confirmado pelo parceiro':
      classColorText = 'color-success'
      iconClassName = 'icon icon_check_circle color-success h4  d-inline-block'
      break
    case 'Enviado para a transportadora':
      classColorText = 'color-success' // Enviado para a transportadora
      iconClassName = 'icon icon_truck color-success h4  d-inline-block' // Enviado para a transportadora
      break
    case 'Em rota de entrega':
      classColorText = 'color-success' // Enviado para a transportadora
      iconClassName = 'icon icon_truck color-success h4  d-inline-block' // Enviado para a transportadora
      break
    case 'Produto com dificuldade na entrega':
      classColorText = 'color-warning' // Produto com dificuldade na entrega
      iconClassName = 'icon icon_truck color-warning h4  d-inline-block' // Produto com dificuldade na entrega
      break
    case 'Estamos indo recolher o produto para troca':
      classColorText = 'color-success'
      iconClassName = 'icon icon_truck color-success h4  d-inline-block'
      break
    case 'Produto foi recolhido':
      classColorText = 'color-success'
      iconClassName = 'icon icon_check_circle color-success h4  d-inline-block'
      break
    case 'Produto não pôde ser recolhido':
      classColorText = 'color-error'
      iconClassName = 'icon icon_truck color-error h4  d-inline-block'
      break
    case 'Estornado':
      classColorText = 'color-error'
      iconClassName = 'icon icon_truck color-error h4  d-inline-block'
      break
    default:
      classColorText = ''
      iconClassName = 'icon icon_check_circle h4  d-inline-block'
      break
  }

  return (
    <ReactPlaceholder ready={props.ready} customPlaceholder={<Placeholder />}>
      <div className='row'>
        <div className='col-auto'>
          <i className={iconClassName} />
        </div>
        <div className='col py-half px-0'>
          <strong
            className={`txt-font-body py-half ${classColorText} txt-body`}
          >
            {props.trackingStatus}
          </strong>
        </div>
      </div>
    </ReactPlaceholder>
  )
}

TrackingStatus.propTypes = {
  trackingStatus: PropTypes.string,
  ready: PropTypes.bool
}

export default TrackingStatus



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderList/ProductOrderItem/ProductDetails/TrackingStatus/TrackingStatus.js